<template>
	<div class="card-wrapper">
		<div class="card">
			<div :class="headerStyling" v-if="!noHeader">
				<slot name="header"></slot>
			</div>
			<div :class="contentStyling">
				<slot name="content"></slot>
			</div>
			<div class="card-footer">
				<slot name="footer"></slot>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Card',
	props: {
		headerClass: {
			type: Object
		},
		contentClass: {
			type: Object
		},
		noHeader: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		headerStyling: function () {
			return Object.assign(
				{
					'card-header': true
				},
				this.headerClass
			)
		},
		contentStyling: function () {
			return Object.assign(
				{
					'card-content': true
				},
				this.contentClass
			)
		}
	}
}
</script>

<style lang="scss" scoped>
$grayColor: #606060;
$headerUnderlineColor: #dedede;

.d-flex {
	width: 100%;
	display: flex;
	.item {
		flex: 1 1 auto;
	}
}

.card-wrapper {
	padding: 0.5rem;
	.card {
		background-color: #fdfdfd;
		color: $grayColor;
		box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
		border-radius: 20px;
		display: flex;
		flex-direction: column;

		.card-item-label {
			font-size: $subFontSize;
			font-weight: bold;
			letter-spacing: 0.1rem;
		}
		.card-item-value {
			margin-top: 0.5rem;
			font-size: $fontSize;
		}

		.hr-text {
			padding: 0.5rem;
			text-align: center;
			color: #c7c7c7;
			position: relative;
			span {
				background: #fff;
				padding: 0 0.5rem;
				position: relative;
				z-index: 2;
				font-size: 0.6rem;
			}
		}
		.hr-text:after {
			content: '';
			display: block;
			width: 100%;
			height: 1px;
			background: #eee;
			position: absolute;
			top: 50%;
			margin-top: -1px;
			left: 0;
			z-index: 1;
		}

		.card-header {
			justify-content: space-between;
			border-bottom: 0.1rem solid $headerUnderlineColor;
			border-radius: 10px;
			padding: 15px;
			align-content: center;
			font-size: 0.7rem;
			flex: 1;
			display: flex;
			margin-bottom: 0.5rem;
		}
		.card-content {
			flex: 1;
			font-size: 0.6rem;
			padding: 10px;
			.card-item {
				margin: 0.2rem;
			}
		}
		.card-footer {
			flex: 1;
			font-size: 0.6rem;
			.operators {
				display: flex;
				justify-content: flex-end;
				button {
					flex: 1;
					width: 4.5rem;
					height: 1.5rem;
					font-size: 0.6rem;
					border-radius: 0.7rem;
					margin: 0.25rem;
					border: 1px solid #ccc;
					box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.08);
				}
			}
		}
	}
}
</style>
